if (!customElements.get('change-limit')) {
  customElements.define(
    'change-limit',
    class ChangeLimitBtn extends HTMLElement {
      constructor() {
        super();
        const selector = this.querySelector('.limiter-options');
        selector.addEventListener('change', (event) => {
          window.location.href = event.target.value;
        });
      }
    }
  );
}
